/**
 * Created by yuxin Wei on 2017/8/4.
 *封装正则regex
*/
export default {
  //考试名称 4~30位中文字符、英文字符、数字字符及-()_
  taskName: /^([a-zA-Z0-9\u4E00-\u9FA5\（）()_-]){4,30}$/,
  //计划名称
  planName: /^([a-zA-Z0-9\u4E00-\u9FA5\（）()_-]){4,20}$/,
  //学生姓名 2~9位汉字、英文、数字组合
  studentName: /^[a-zA-Z0-9\u4E00-\u9FA5]{2,9}$/,
  //学号 8~22位英文、数字组合
  studentId: /^[0-9a-zA-Z]{8,22}$/,
  //3~30位汉字、字母、数字、括号组合 示例：初三（1）班
  className: /^([0-9a-zA-Z\u4E00-\u9FA5\（）()]){3,30}$/,
  //班级号 首字母C+12位数字
  classId: /^C[0-9]{12}$/,
  //邮箱
  email: /(\w|-)+@((\w|-)+\.)+[a-z]{2,5}/,
  //登录名
  userName: /^[a-zA-Z]{1}([a-zA-Z0-9]){3,29}$/,
  //密码
  password: /^(\w){6,30}$/,
  //真实姓名
  realname: /^[a-zA-Z0-9\u4E00-\u9FA5]{2,9}$/,
  //手机号码
  telephone: /^1\d{10}$/,
  //前后空格
  aroundSpace: /(^\s*)|(\s*$)/g,
  //中间空格替换成' '
  centerSpace: /\s+/g,
  //数字格式化小数
  isAllZero: /[1-9]{1,}/,
  //匹配正整数
  isNum:/^[1-9]\d*$/,
  //匹配搜索框的字符
  searchSpace:/^([a-zA-Z0-9\u4E00-\u9FA5\s&:：（）()_-])/
}



// WEBPACK FOOTER //
// ./src/common/regex.js